import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

export const WhyKeenContainer = styled('div')(
  ({ theme }: { theme?: Theme }) => ({
    padding: '0 10px',
    '& .why-keen-content': {
      lineHeight: 1.42,
      fontSize: '16px',
      marginTop: '25px'
    },
    [theme.breakpoints.up('sm')]: {
      padding: '0 19px',
      maxWidth: '768px',
      margin: '0 auto'
    },
    [theme.breakpoints.up('md')]: {
      padding: '0 21px',
      maxWidth: '992px'
    },
    [theme.breakpoints.up('lg')]: {
      padding: '0 60px',
      maxWidth: '1200px'
    }
  })
);

export default WhyKeenContainer;
